import { useState } from 'react';
import { useAuthStore } from '../store';
import api from '../api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { User, Mail, Lock, Loader2 } from 'lucide-react';

export default function ProfilePage() {
  const { user, fetchUser } = useAuthStore();
  const [username, setUsername] = useState(user?.username || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    if (newPassword && newPassword !== confirmPassword) { toast.error('Passwords do not match'); return; }
    
    setIsLoading(true);
    try {
      await api.put('/auth/profile', null, { params: { username: username !== user?.username ? username : undefined, current_password: currentPassword || undefined, new_password: newPassword || undefined } });
      toast.success('Profile updated!');
      setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
      fetchUser();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Update failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold text-white font-['Outfit']">Profile Settings</h1>

      <Card className="bg-[#0A0A0A] border-white/10">
        <CardHeader><CardTitle className="text-white flex items-center gap-2"><User className="w-5 h-5 text-[#FFD700]" />Account Info</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-4 p-4 bg-[#121212] rounded-lg">
            <div className="w-16 h-16 rounded-full bg-[#FFD700]/20 flex items-center justify-center"><span className="text-2xl font-bold text-[#FFD700]">{user?.username?.charAt(0).toUpperCase()}</span></div>
            <div><p className="text-lg font-semibold text-white">{user?.username}</p><p className="text-zinc-500">{user?.email}</p></div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-[#0A0A0A] border-white/10">
        <CardHeader><CardTitle className="text-white">Update Profile</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={handleUpdateProfile} className="space-y-4">
            <div className="space-y-2">
              <Label className="text-zinc-300">Username</Label>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} className="bg-[#121212] border-white/10 text-white" />
            </div>
            <div className="border-t border-white/10 pt-4">
              <p className="text-sm text-zinc-400 mb-4">Change Password (leave blank to keep current)</p>
              <div className="space-y-4">
                <div className="space-y-2"><Label className="text-zinc-300">Current Password</Label><Input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} className="bg-[#121212] border-white/10 text-white" /></div>
                <div className="space-y-2"><Label className="text-zinc-300">New Password</Label><Input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="bg-[#121212] border-white/10 text-white" /></div>
                <div className="space-y-2"><Label className="text-zinc-300">Confirm New Password</Label><Input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="bg-[#121212] border-white/10 text-white" /></div>
              </div>
            </div>
            <Button type="submit" disabled={isLoading} className="w-full bg-[#FFD700] text-black hover:bg-[#E5C100] font-bold">
              {isLoading ? <><Loader2 className="w-4 h-4 animate-spin mr-2" />Saving...</> : 'Save Changes'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
